import request from '@/utils/request'

// 查询合同管理列表
export function listOtherContract(query) {
  return request({
    url: '/cont/othercontract/list',
    method: 'get',
    params: query
  })
}

// 查询合同管理详细
export function getOtherContract(contractId) {
  return request({
    url: '/cont/othercontract/' + contractId,
    method: 'get'
  })
}

// 新增合同管理
export function addOtherContract(data) {
  return request({
    url: '/cont/othercontract',
    method: 'post',
    data: data
  })
}

// 修改合同管理
export function updateOtherContract(data) {
  return request({
    url: '/cont/othercontract',
    method: 'put',
    data: data
  })
}

// 删除合同管理
export function delOtherContract(contractId) {
  return request({
    url: '/cont/othercontract/' + contractId,
    method: 'delete'
  })
}

// 导出合同管理
export function exportContract(query) {
  return request({
    url: '/cont/othercontract/export',
    method: 'get',
    params: query
  })
}

// 下载客户导入模板
export function importTemplate() {
  return request({
    url: '/cont/othercontract/importTemplate',
    method: 'get'
  })
}